var map = {
	"./action_tacos.jpg": 2597,
	"./alfredo.jpg": 8961,
	"./avocado_toast.jpg": 7096,
	"./back.png": 6637,
	"./bananabread.jpg": 3100,
	"./beef_stew.jpg": 1988,
	"./breakfast_burrito.jpg": 5443,
	"./brussel_sprouts.jpg": 2058,
	"./butter_chicken1.jpg": 3427,
	"./buttermilk_chicken_tenders.jpg": 1973,
	"./butternut1.jpg": 5849,
	"./carrots1.jpg": 5119,
	"./cheesy_mac.jpg": 8620,
	"./chili.jpg": 5174,
	"./chowder.jpg": 809,
	"./cooking_logo4.png": 298,
	"./crossaint1.png": 365,
	"./curry_udon.jpg": 3836,
	"./curryhouse1.jpg": 7446,
	"./eggplant_lasagna2.jpg": 986,
	"./fried_rice1.jpg": 7158,
	"./ham.jpg": 5623,
	"./kalbi1.jpg": 5686,
	"./kaluapigcabbage1.jpg": 1870,
	"./kewpie_dressing.jpg": 8043,
	"./korokke1.jpg": 6082,
	"./lasagna.jpg": 1645,
	"./locomoco1.jpg": 1232,
	"./mabo_tofu.jpg": 2237,
	"./mabotofu.jpg": 9681,
	"./mac_salad.jpg": 5779,
	"./meatjun1.jpg": 7368,
	"./miso_soup.jpg": 8478,
	"./mochiko_chicken.jpg": 5869,
	"./next.png": 1828,
	"./next_clicked.png": 7342,
	"./no_picture_yet.jpg": 7957,
	"./ozoni.jpg": 1136,
	"./prev.png": 4104,
	"./prev_clicked.png": 4592,
	"./rafute2.jpg": 9837,
	"./ramen.jpg": 2133,
	"./roasted_asparagus.jpg": 3150,
	"./spaghetti.jpg": 1704,
	"./spam_cabbage.jpg": 4833,
	"./spicy_tantan.jpg": 9795,
	"./stuffed_shells.jpg": 561,
	"./tacos.jpg": 7809,
	"./tamagosando.jpg": 3071,
	"./testimg.svg": 2675,
	"./thin_pork.jpg": 4555,
	"./turkey_meatballs3.jpg": 3192,
	"./wallpaper.png": 9943
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8070;